import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';


function CandidatureArbitrage(props) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [commentaire, setCommentaire] = useState();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setConfirmation(false);

      try {
        await axios.post(`${apiUrl}/arbitrage/candidature/ajouter`, {
          idArbitre : props.userData.user.donnée.results[0].id,
          idMatch : props.equipe.id_match,
          commentaireArbitre : commentaire
        }, {
          withCredentials: true
        });
  
        setError(null);
        setIsLoading(false);
        window.location.reload(); 

      } catch (error) {
        console.log(error)
        if (error.response) {
          setIsLoading(false)
          setError(error.response.data.message);
        } else {
          setIsLoading(false)
          setError(true);
        }
      }
    };

  
        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }
        if(error){
            return (
                <>
                <div id="alert-message" className="alert4" >
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
              </>  
            )
        }

  return (
    <>
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmer votre candidature</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>Voulez-vous vraiment envoyer votre candidature pour ce match ?</>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.equipe && 
        <>
          <Card.Header></Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Card.Text><strong>Se proposer pour arbitrer ce match  </strong> </Card.Text>
              <Form.Label>Commentaire</Form.Label>
              <Form.Control as="textarea" onChange={(e) => setCommentaire(e.target.value)} rows={3}  />
            </Form.Group>
            <Button variant="primary" onClick={() => setConfirmation(true)}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Envoyer une candidature </Button>
          </Card.Body> 
        </>
    }


    </>
  );
}

export default CandidatureArbitrage;